import { useAdministrativeContext } from '../../../../../../../../pages/administrativePanel/administrativePanelContext'
import { FaTimesCircle } from 'react-icons/fa'

import { BusinessContent } from './style'


export function Business({ businesses }) {
    const { removingFromArrayBusiness } = useAdministrativeContext()

    function removeBusinessFromFilter(i) {
        removingFromArrayBusiness([i])
    }

    
    return(
        <BusinessContent>
            {
                businesses.map((business) => (
                    <div 
                        key={business.id}
                        className='text'
                    >
                        <p>
                            {business.name}
                        </p>

                        <FaTimesCircle 
                            onClick={() => removeBusinessFromFilter(business.id)}
                        />
                    </div>
                
                ))
            }
        </BusinessContent>
    )
}
